import clickIcon from '@/assets/event-models/click.svg';
import clickPrototypeIcon from '@/assets/event-models/click-prototype.svg';
import dragIcon from '@/assets/event-models/drag.svg';
import groupClickIcon from '@/assets/event-models/groupclick.svg';
import longPressIcon from '@/assets/event-models/longpress.svg';
import longPressPrototypeIcon from '@/assets/event-models/longpress-prototype.svg';
import rapidClickIcon from '@/assets/event-models/rapidclick.svg';
import rapidClickPrototypeIcon from '@/assets/event-models/rapidclick-prototype.svg';
import selectIcon from '@/assets/event-models/select.svg';
import selectPrototypeIcon from '@/assets/event-models/select-prototype.svg';
import slideIcon from '@/assets/event-models/slide.svg';
import slidePrototypeIcon from '@/assets/event-models/slide-prototype.svg';
import homeFeaturedProject from '@/assets/backgrounds/home/featured-project.jpg';
import greyAvatar from '@/assets/avatars/avatar-grey.png';
import userAvatar from '@/assets/user.png';
import menuInteractionIcon from '@/assets/icons/menu-interaction.svg';
import menuMaterialIcon from '@/assets/icons/menu-material.svg';
import menuVideoIcon from '@/assets/icons/menu-video.svg';
import projectMusicIcon from '@/assets/icons/project-music.svg';
import projectPicIcon from '@/assets/icons/project-pic.svg';
import projectTextIcon from '@/assets/icons/project-text.svg';
import defaultAudioCover from '@/assets/media/default-audio.png';
import choiceBackground from '@/assets/media/choice-background.png';
import artStyle2dCel from '@/assets/media/art-styles/2d-cel.jpg';
import artStyle2dComic from '@/assets/media/art-styles/2d-comic.jpg';
import artStyle2dPixel from '@/assets/media/art-styles/2d-pixel.jpg';
import artStyle3dArtisticGuofeng from '@/assets/media/art-styles/3d-artistic-guofeng.jpg';
import artStyle3dChineseAncient from '@/assets/media/art-styles/3d-chinese-ancient.jpg';
import artStyle3dPixar from '@/assets/media/art-styles/3d-pixar.jpg';
import artStyleAmericanComic from '@/assets/media/art-styles/american-comic.jpg';
import artStyleArcane from '@/assets/media/art-styles/arcane.jpg';
import artStyleGhibli from '@/assets/media/art-styles/ghibli.jpg';
import artStyleGuofengLineart from '@/assets/media/art-styles/guofeng-lineart.jpg';
import artStyleIllustration from '@/assets/media/art-styles/illustration.jpg';
import artStyleLiveAction from '@/assets/media/art-styles/live-action.jpg';
import artStyleOilPainting from '@/assets/media/art-styles/oil-painting.jpg';
import artStyleOrigamiStopMotion from '@/assets/media/art-styles/origami-stop-motion.jpg';
import artStyleRetroHongkong from '@/assets/media/art-styles/retro-hongkong.jpg';
import artStyleShinkai from '@/assets/media/art-styles/shinkai.jpg';
import imagePoster from '@/assets/media/image-poster.png';
import videoPoster from '@/assets/media/video-poster.png';
import projectForestHouse from '@/assets/media/home/project-forest-house.jpg';
import projectForgottenLand from '@/assets/media/home/project-forgotten-land.jpg';
import projectHerChoice from '@/assets/media/home/project-her-choice.jpg';
import projectRainNight from '@/assets/media/home/project-rain-night.jpg';
/** 当前恢复阶段的本地静态资源入口，禁止组件直接引用文件路径。 */
export const assetManifest = {
    home: {
        featuredProject: homeFeaturedProject,
        avatar: greyAvatar,
        userAvatar,
        projectCovers: [projectRainNight, projectForgottenLand, projectHerChoice, projectForestHouse],
    },
    navigation: {
        video: menuVideoIcon,
        interaction: menuInteractionIcon,
        materials: menuMaterialIcon,
    },
    eventModels: {
        select: selectIcon,
        click: clickIcon,
        groupclick: groupClickIcon,
        rapidclick: rapidClickIcon,
        longpress: longPressIcon,
        slide: slideIcon,
        drag: dragIcon,
        passivity: projectMusicIcon,
        image: projectPicIcon,
        text: projectTextIcon,
    },
    eventLibraryModels: {
        click: clickPrototypeIcon,
        rapidclick: rapidClickPrototypeIcon,
        longpress: longPressPrototypeIcon,
        slide: slidePrototypeIcon,
        'image-text-choice': selectPrototypeIcon,
    },
    media: {
        videoPoster,
        imagePoster,
        imageType: projectPicIcon,
        audioType: projectMusicIcon,
        materialFallbacks: {
            image: projectPicIcon,
            video: menuVideoIcon,
            audio: defaultAudioCover,
            file: projectTextIcon,
        },
        choiceBackground,
    },
    artStyles: {
        shinkai: artStyleShinkai,
        '2d-comic': artStyle2dComic,
        'retro-90s': artStyleRetroHongkong,
        '2d-pixel-illustration': artStyleIllustration,
        '2d-pixel': artStyle2dPixel,
        ghibli: artStyleGhibli,
        'american-comic': artStyleAmericanComic,
        '2d-anime': artStyle2dCel,
        'ink-wash': artStyleGuofengLineart,
        '3d-ancient': artStyle3dChineseAncient,
        '3d-anime': artStyle3dPixar,
        '3d-american-anime': artStyle3dArtisticGuofeng,
        'stop-motion': artStyleOrigamiStopMotion,
        arcane: artStyleArcane,
        'oil-painting': artStyleOilPainting,
        'live-action-original': artStyleLiveAction,
    },
};
